import { Component, OnInit } from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { FormControl } from '@angular/forms';
import type { Observable } from 'rxjs';
import { map } from 'rxjs';
import { AppStateService } from 'src/app/shared/services/app-state.service';
import { ClinicService } from 'src/app/shared/services/clinic.service';
import { TokenStorageService } from 'src/app/shared/services/token-storage.service';
import { UserService } from 'src/app/shared/services/user.service';
import { IDialogContentComponent } from 'src/app/shared/components/modal-dialog/modal-dialog.service';
import { EntityItemInterface } from 'src/app/shared/components/search-input/select-item.interface';


@Component({
  selector: 'app-share-by-app',
  templateUrl: './share-by-app.component.html',
  styleUrls: ['./share-by-app.component.scss']
})
export class ShareByAppComponent implements OnInit, IDialogContentComponent<ShareEntityPopupResult, ShareEntityPopupInput> {
  input: ShareEntityPopupInput; // Filter my clinic

  separatorKeysCodes: number[] = [ENTER, COMMA];
  usersCtrl = new FormControl();
  shareWithGroupFormControl = new FormControl(false);

  selectedUsers: number[] = [];
  selectedClinics: number[] = [];
  selectedUserClinicId: number;
  onFilterUsers: (args: string) => Observable<EntityItemInterface[]>;
  onFilterClinics: (args: string) => Observable<EntityItemInterface[]>;

  isInGroup: boolean;

  constructor(
    public userService: UserService,
    private readonly clinicService: ClinicService,
    private readonly appStateService: AppStateService,
    private readonly tokenStorageService: TokenStorageService
  ) { }

  getResult(): ShareEntityPopupResult {
    return {
      clinics : this.selectedClinics,
      users : this.selectedUsers,
      shareWithMyGroup : this.shareWithGroupFormControl.value ?? false
    };
  }

  isDisabled(): boolean {
    return this.selectedUsers.length === 0
          && this.selectedClinics.length === 0
          && this.shareWithGroupFormControl.value === false;
  }

  ngOnInit(): void {
    this.isInGroup = this.appStateService.clinic?.hasSisters ?? false ;
    this.onFilterUsers = (value: string ) => {
      const clinicId = this.selectedUserClinicId;
      const currentUserId = this.tokenStorageService.getUserId();
      return this.userService.searchUsers(value, clinicId).pipe(map(items => items.filter(i=> i.id !== currentUserId).map(item => ({ id: item.id, label :item.firstName + ' ' + item.lastName })) ));
    };

    this.onFilterClinics = (value: string ) => this.clinicService.searchAllClinics(value).pipe(
      map(clinics => {
        const filteredClinics = clinics.filter(clinic => clinic.id !== this.appStateService.clinicId);
        return filteredClinics.map(item => ({ id: item.id, label: item.name }));
      })
    );
  }

  onSelectedUsersChanged(users: EntityItemInterface[]) {
    this.selectedUsers =  users.map(u=> u.id);
  }

  onSelectedClinicsChanged(clinics: EntityItemInterface[]) {
    this.selectedClinics =  clinics.map(u=> u.id);
  }

  onSelectedUserClinicChanged(clinic: EntityItemInterface) {
    this.selectedUserClinicId =  clinic.id;
  }
}

export interface ShareEntityPopupResult {
  users: number[];
  clinics: number[];
  shareWithMyGroup: boolean;
}

export interface ShareEntityPopupInput {
  filterClinic: boolean;
  entityId: number;
  isStudy: boolean;
}


